import { useTranslation } from 'react-i18next'
import Header from '@/components/layout/header'
import Footer from '@/components/layout/footer'
import AboutHero from './hero'
import Principles from './principles'
// import Team from './team'
// import Locations from './locations'
import AboutCta from './cta'
import Seo from '@/components/seo/seo'
import { breadcrumbSchema } from '@/components/seo/json-ld'
import { resolveLang } from '@/lib/site'

export default function About() {
  const { t, i18n } = useTranslation()
  const lang = resolveLang(i18n.resolvedLanguage)

  return (
    <>
      <Seo
        title={t('seo.about.title') as string}
        description={t('seo.about.description') as string}
        path="/about"
        jsonLd={breadcrumbSchema(lang, [
          { name: 'Bravic', path: '/' },
          { name: t('seo.about.title') as string, path: '/about' },
        ])}
      />
      <Header />
      <main className="relative pt-20 md:pt-28 lg:pt-32 pb-12 md:pb-24 overflow-hidden bg-[radial-gradient(circle_at_20%_30%,rgba(0,166,147,0.05)_0%,transparent_50%),radial-gradient(circle_at_80%_70%,rgba(91,218,198,0.03)_0%,transparent_50%)]">
        <AboutHero />
        <Principles />
        {/* <Team /> */}
        {/* <Locations /> */}
        <AboutCta />
      </main>
      <Footer />
    </>
  )
}
